import { formatApi, postGoRelay } from './baseApi';
import { Message } from 'element-ui';
import store from '@/store';
import { ruleAPI } from '../http/fetch';


// 获取配置中心配置项
export async function getConfCenterInfo(params) {
  const result = await formatApi({
    Action: 'ConfCenter',
    Data: {
      ConfigKeyList: params,
      IsJsonToObject: true,
    },
    Method: 'Query',
  });

  const { data } = result;
  if (data.status !== 0) {
    Message({
      type: 'error',
      message: `获取配置中心配置项（ConfCenter）出错：${data.msg}`,
    });
    throw new Error(data.msg);
  }

  return data;
}

// NDB通用查询接口
export async function getInfoByNdb(Columns, Conditions, SchemeId = 'Netdevice') {
  const result = await formatApi({
    Action: 'Ndb',
    Columns,
    Conditions,
    Method: 'Query',
    SchemeId,
  });

  const { data } = result;
  if (data.status !== 0) {
    Message({
      type: 'error',
      message: `NDB通用查询接口（getInfoByNdb）出错：${data.msg}`,
    });
    throw new Error(data.msg);
  }

  return data;
}

// CMDB通用查询接口
export async function getInfoByCmdb(Columns, Conditions, SchemeId, Start, PageSize) {
  const result = await formatApi({
    Action: 'Cmdb',
    Columns,
    Conditions,
    Method: 'Query',
    SchemeId,
    Start,
    PageSize,
  });

  const { data } = result;
  if (data.status !== 0) {
    Message({
      type: 'error',
      message: `CMDB通用查询接口（getInfoByCmdb）出错：${data.msg}`,
    });
    throw new Error(data.msg);
  }
  return data;
}

// 用JSONP方式查询所有用户数据
export async function getAllUsers() {
  const data = await jsonpGetUserData({
    url: store.getters.getConfigItem('top_oa_url'),
  });

  const list = [];
  data.forEach((item) => {
    list.push({
      name: item[0],
      fullName: item[1],
    });
  });

  return list;
}

// 根据文件名获取配置文件
export async function getConfigDoc(filename) {
  const result = await formatApi({
    Action: 'ConfigBak',
    Method: 'GetConfigBakContent',
    SystemId: '1',
    Data: {
      FileName: filename,
    },
  });

  const { data } = result;
  if (data.status !== 0) {
    Message({
      type: 'error',
      message: `配置信息文件查询接口（getInfoByCmdb）出错：${data.msg}`,
    });
    throw new Error(data.msg);
  }
  return data;
}

function jsonpGetUserData(config) {
  return new Promise((resolve, reject) => {
    let script = document.createElement('script');
    const src = config.url;
    script.async = true;
    const onChange = () => {
      if (!script.readyState || /loaded|complete/.test(script.readyState)) {
        resolve(window._arrusers);
        removeScript();
      }
    };
    script.onload = onChange;
    script.onreadystatechange = onChange;
    // function() {
    //   if (!script.readyState || /loaded|complete/.test(script.readyState)) {
    //     resolve(window._arrusers);
    //     removeScript();
    //   }
    // };
    script.onerror = function() {
      removeScript();
      reject(new Error('Network Error：获取全部用户列表出错'));
    };
    script.src = src;
    document.head.appendChild(script);

    function removeScript() {
      if (script) {
        script.onload = null;
        script.onreadystatechange = null;
        script.onerror = null;

        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
        script = null;
      }
    }
  });
}

export async function postHunyuan(Query, ForwardService, params = {}) {
  const result = await postGoRelay('/e2e', {
    Action: 'NetOpsAI',
    Method: 'UrlProxyWithHttp',
    SystemId: '2',
    Data: {
      Authorization: '7auGXNATFSK17dF',
      Query,
      ForwardService: ForwardService || 'hyaide-application-19337',
      ExtData: {
        stream: false,
        ...params
      },
    },
  });


  return result;
}